import z from 'zod';

export const ZodTransferMeta = z.object({
  blockId: z.uuid(),
  volume: z.number().min(0.001),
  recipientId: z.uuid(),
  accountId: z.uuid(),
});

export type TransferMeta = z.infer<typeof ZodTransferMeta>;
